/**
 * Navigate back safely from detail pages (email deep links, new tabs, post-login).
 * Falls back to `fallbackPath` when there is no usable in-app history.
 */
export function navigateBackSafely(navigate, fallbackPath) {
  if (!fallbackPath) {
    navigate(-1);
    return;
  }

  try {
    const historyIdx = window.history.state?.idx;
    const referrer = typeof document !== 'undefined' ? document.referrer || '' : '';
    const sameOriginReferrer =
      !!referrer && referrer.startsWith(window.location.origin);

    // Fresh tab / direct open / no prior RR entry
    if (historyIdx === 0 || historyIdx == null) {
      navigate(fallbackPath, { replace: true });
      return;
    }

    // Opened from email/external site with a shallow stack — avoid blank/external back
    if (!sameOriginReferrer && historyIdx <= 1) {
      navigate(fallbackPath, { replace: true });
      return;
    }

    navigate(-1);

    // After auth redirects, back can land on login — correct to listing
    setTimeout(() => {
      const path = window.location.pathname || '';
      if (
        path.includes('/login') ||
        path.includes('/page-login') ||
        path === '/' ||
        path === ''
      ) {
        navigate(fallbackPath, { replace: true });
      }
    }, 150);
  } catch {
    navigate(fallbackPath, { replace: true });
  }
}
